import { FarmData } from 'types/FarmData';
import { FarmCard } from 'ui/Card/FarmCard';

interface FarmPartnersProps {
  partners: FarmData[];
}

const FarmPartners = ({ partners }: FarmPartnersProps) => (
  <div className={'farm-partner-cards'}>
    {partners.map((partner) => (
      <FarmCard key={partner.id} farm={partner} hoverable row />
    ))}
  </div>
);

export default FarmPartners;
